module.exports = __webpack_public_path__ + "static/media/ICON_chevronLeft_light.49fc596d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/ICON_chevronLeft_light.svg
// module id = 687
// module chunks = 0